import React from "react";
import { Col, Row, Form, Radio } from "antd";
import { Secured } from "../../component";
import Painel from "gp-painel";
import { Permissions } from "../../Constantes/permissions.constants";

const PermiteContato = ({ nome, form }) => {

  
  return (
    <Secured hasAnyRole={Permissions.RECADASTRAMENTO.TELA} isShowErro403={true}>
      <Painel subTitulo="Permissão de Contato">
        <Row>
          <Col xs={24} sm={24} md={18} lg={18} style={{ display: "flex", alignItems: "center" }}>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <strong style={{ fontSize: "1.5rem", marginBottom: 8 }} >
              <span style={{ color: "red", marginLeft: 4, fontSize: "1.7rem" }}>*  </span>
                 Permitir contato/correspondência.
              </strong>
              <span style={{ fontSize: "1.3rem", fontWeight: "normal", marginBottom: 12 }}>
                Ao selecionar esta opção, o segurado autoriza, quando necessário, a realização de contato utilizando os dados fornecidos, seja por telefone, e-mail ou correspondência física.
              </span>
              <Form.Item
                name={[nome, "autorizaContato"]}
                rules={[{ required: true, message: "Por favor, selecione uma opção!" }]}
              >
                <Radio.Group>
                  <Radio value={true} style={{ fontSize: "1.3rem", marginRight: 24 }}>Sim</Radio>
                  <Radio value={false} style={{ fontSize: "1.3rem" }}>Não</Radio>
                </Radio.Group>
              </Form.Item>
            </div>

          </Col>
        </Row>
      </Painel>
    </Secured>
  );
};

export default PermiteContato;
